import { useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

export function usePushNotifications() {
  const registerServiceWorker = useCallback(async () => {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) return;
    if (!VAPID_PUBLIC_KEY) return;

    try {
      // Register service worker
      const reg = await navigator.serviceWorker.register("/sw.js");
      await navigator.serviceWorker.ready;

      // Check existing subscription
      const existing = await reg.pushManager.getSubscription();
      if (existing) {
        // Re-send to backend in case it was lost
        await axios.post(`${API}/parent-communication/parent/push-subscribe`, {
          subscription: existing.toJSON(),
        });
        return;
      }

      // Request permission
      const permission = await Notification.requestPermission();
      if (permission !== "granted") return;

      // Subscribe
      const subscription = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
      });

      await axios.post(`${API}/parent-communication/parent/push-subscribe`, {
        subscription: subscription.toJSON(),
      });
    } catch (e) {
      // Silently fail — push is enhancement only
    }
  }, []);

  useEffect(() => {
    registerServiceWorker();
  }, [registerServiceWorker]);
}
